import React, { Component } from 'react';
import icon from '../img/whatsapp-color.svg';
import { contact } from '../config';


export default class WhatsAppButton extends Component {
	render() {
		return (
			<div 
			onClick={() => this.props.onClick?.()}
			className={"whatsapp-icon"+(this.props.class?' '+this.props.class:'')}>
		        <a href={"https://api.whatsapp.com/send?phone="+contact.whatsappPlain+"&amp;text=¡Hola%20Abastible!"} target={"_blank"}>
		            <img src={icon} alt='icono whatsapp'/>
		            <span>
		                {this.props.text?this.props.text:"Pide gas cilindro y tanque Aquí"}
		            </span>
		        </a>
		    </div>
		);
	}
}